// #region IMPORTS
import PropTypes from 'prop-types';
import React from 'react';
// #endregion

//#region COMPONENT
/**
 * @returns The tooltip for duplication control
 * @param {Object} props
 * @param {React.ReactNode} props.children - The content of the tooltip
 * @description The tooltip for duplication control, displayed on hover on the duplication control
 * It is a simple wrapper around the content to apply the correct style and position
 */
const DuplicationTooltip = props => {
  //#region INITIALISATION
  const { children } = props;
  //#endregion

  //#region INTERFACE

  return <div className="Duplication-tooltip">{children}</div>;
};
//#endregion

//#region PROPERTIES
DuplicationTooltip.propTypes = {
  children: PropTypes.node,
};
//#endregion

export { DuplicationTooltip };
